module.exports = __webpack_public_path__ + "img/piyao_4.70a7bd2d.png";